module.exports = __webpack_public_path__ + "img/instagram.7ac3de1a.svg";